import {useState, useCallback, Fragment} from "react";

// import Badge from "@material-ui/core/Badge";
// import ErrorIcon from "@material-ui/icons/Error";
// import BatteryCharging80Icon from "@material-ui/icons/BatteryCharging80";
// import CloudQueueIcon from "@material-ui/icons/CloudQueue";
import { Box, IconButton,  Menu, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import ReorderIcon from "@mui/icons-material/Reorder";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import useDebouncedEffect from "../../lib/useDebouncedEffect";
import { SearchSingle } from "../../components/Search";
import { BoxFilterBarCustomInvert } from "../../Theme/ContainerStyle";
import { TooltipCustom } from "../../Theme/TooltipStyle";


export default function FiltersBar({onSearchTermChange, toggleView, onToggleView}) {

  const [searchTerm, setSearchTerm] = useState("");
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMobileMenuClose = useCallback(() => setMobileMoreAnchorEl(null), []);
  const handleMobileMenuOpen = useCallback((event) => setMobileMoreAnchorEl(event.currentTarget), []);
  const handleSearchTermChange = useCallback((value) => setSearchTerm(value), []);

  useDebouncedEffect(() => {
    onSearchTermChange(searchTerm);
  },500,[searchTerm]);

  const mobileMenuId = "primary-search-account-menu-mobile";

  return (
    <Fragment>
      <Toolbar disableGutters>
        <Box className={"site-search-filter"}>
          <SearchSingle onChange={handleSearchTermChange}/>
        </Box>
        <Box sx={{flexGrow:1}}/>

        {matches && <Box className={"show-brand-filter"}>
          <TooltipCustom title="Mostra Brand" placement="top">
            <IconButton color={toggleView ? "primary" : "secondary"} onClick={onToggleView}>
              <ReorderIcon />
            </IconButton>
          </TooltipCustom>

          {/* <Tooltip title="Mostra Errori" placement="top" arrow>
            <IconButton color="secondary">
              <Badge badgeContent={4} color="error">
                <ErrorIcon />
              </Badge>
            </IconButton>
          </Tooltip>

          <Tooltip title="Mostra HACCP" placement="top" arrow>
            <IconButton color="secondary">
              <Badge badgeContent={17} color="primary">
                <CloudQueueIcon />
              </Badge>
            </IconButton>
          </Tooltip>

          <Tooltip title="Mostra Energy" placement="top" arrow>
            <IconButton color="secondary" edge="end">
              <Badge badgeContent={17} color="primary">
                <BatteryCharging80Icon />
              </Badge>
            </IconButton>
          </Tooltip> */}
        </Box>}

        {/* <div className={clsx(classes.sectionMobile, "show-brand-filter")}> */}
        {/* <Box
          className={ "show-brand-filter"}
          sx={(theme) => ({
            display: "flex",
            [theme.breakpoints.up("sm")]: {display: "none",},
          })}> */}
        <BoxFilterBarCustomInvert className={"show-brand-filter"}>
          <IconButton onClick={handleMobileMenuOpen} color="secondary">
            <ExpandMoreIcon />
          </IconButton>
        </BoxFilterBarCustomInvert>
      </Toolbar>

      <Menu
        anchorEl={mobileMoreAnchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id={mobileMenuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
      >

        {/* <MenuItem color="secondary">
          <ListItemIcon>
            <Badge badgeContent={4} color="error">
              <ErrorIcon fontSize="small" />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Mostra Errori" />
        </MenuItem>
        <MenuItem color="secondary">
          <ListItemIcon>
            <Badge badgeContent={17} color="primary">
              <CloudQueueIcon fontSize="small" />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Mostra HACCP" />
        </MenuItem>
        <MenuItem color="secondary">
          <ListItemIcon>
            <Badge badgeContent={17} color="primary">
              <BatteryCharging80Icon fontSize="small" />
            </Badge>
          </ListItemIcon>
          <ListItemText primary="Mostra Energy" />
        </MenuItem> */}
      </Menu>
    </Fragment>
  );
}
